import DOMPurify from 'dompurify';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { noClientsDemoI18n } from '../i18n';
import { formatChileDateTime } from './threadUtils';
import './emailThread.scss';

// Hilo de correo del cierre. El HTML viene de HubSpot (remitentes externos) => se sanitiza
// SIEMPRE con DOMPurify antes de inyectarlo (evita XSS por HTML de terceros).
export default function EmailThread({ emails }) {
  const { t } = useScopedTranslation(noClientsDemoI18n);
  const items = Array.isArray(emails) ? emails : [];

  return (
    <div className='email-thread'>
      {items.map((e) => {
        const isOut = String(e.direction || '').toLowerCase() === 'out';
        const safeHtml = e.bodyHtml
          ? DOMPurify.sanitize(e.bodyHtml, { USE_PROFILES: { html: true } })
          : null;
        return (
          <div
            key={e.hubspotEmailId}
            className={`email-item ${isOut ? 'out' : 'in'}`}
          >
            <div className='email-head'>
              <strong>{isOut ? t('chat_consultant') : t('chat_client')}</strong>
              <span className='caption color-gray-600'>
                {formatChileDateTime(e.occurredAt)}
              </span>
            </div>
            {e.subject && (
              <div className='email-subject'>
                <strong>{t('nc_th_subject')}:</strong> {e.subject}
              </div>
            )}
            <div className='email-meta caption color-gray-600'>
              {t('nc_th_from')}: {e.fromEmail || '--'} · {t('nc_th_to')}:{' '}
              {e.toEmail || '--'}
            </div>
            {safeHtml ? (
              <div
                className='email-body'
                dangerouslySetInnerHTML={{ __html: safeHtml }}
              />
            ) : (
              <div className='email-body'>
                {e.bodyText || t('nc_th_noContent')}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
